(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cardProductSwiperBound) return;
    window.__cardProductSwiperBound = true;

    function initSingleProductCardSwiper(el) {
      if (!el || el.dataset.swiperInitialized === 'true' || typeof Swiper === 'undefined') return;

      var slidesCount = el.querySelectorAll('.swiper-slide').length;
      var paginationEl = el.querySelector('.swiper-pagination');

      // No need to initialize Swiper for single-image cards.
      if (slidesCount <= 1) {
        if (paginationEl) paginationEl.style.display = 'none';
        el.dataset.swiperInitialized = 'true';
        return;
      }

      el.dataset.swiperInitialized = 'true';

      var isDragging = false;
      el.addEventListener(
        'click',
        function (event) {
          if (!isDragging) return;
          var link = event.target.closest('.card__media-link');
          if (!link) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 8,
        threshold: 6,
        preventClicks: true,
        preventClicksPropagation: true,
        watchOverflow: true,
        on: {
          touchStart: function () {
            isDragging = false;
          },
          sliderMove: function () {
            isDragging = true;
          },
          touchEnd: function () {
            setTimeout(function () {
              isDragging = false;
            }, 120);
          },
        },
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : undefined,
      });
    }

    var cardSwiperObserver;
    function initProductCardSwipers() {
      if (typeof Swiper === 'undefined') return;

      // Lazy-init swipers only when near viewport to reduce mobile memory spikes
      if (!cardSwiperObserver && 'IntersectionObserver' in window) {
        cardSwiperObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              initSingleProductCardSwiper(entry.target);
              cardSwiperObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '300px 0px' }
        );
      }

      var swipers = document.querySelectorAll('.product-card-swiper');
      swipers.forEach(function (el) {
        if (el.dataset.swiperInitialized === 'true') return;
        if (cardSwiperObserver) {
          cardSwiperObserver.observe(el);
        } else {
          // Fallback for older browsers
          initSingleProductCardSwiper(el);
        }
      });
    }

    var initTimer;
    function scheduleInit() {
      clearTimeout(initTimer);
      initTimer = setTimeout(initProductCardSwipers, 60);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleInit);
    } else {
      scheduleInit();
    }

    document.addEventListener('shopify:section:load', scheduleInit);
    document.addEventListener('collection:rendered', scheduleInit);
  })();
  } catch(e) { console.error(e); }
})();

})();
